import type { Tag } from './types';
import { TAG_GROUPING_CONFIG } from './constants';

/**
 * Checks if a tag is considered a family tag based on business rules
 *
 * @param tag - The tag to evaluate
 * @returns True if the tag represents a family/group
 */
export function isFamilyTag(tag: Tag): boolean {
  return (
    tag.slug.includes(TAG_GROUPING_CONFIG.FAMILY_SUFFIX) ||
    tag.slug === TAG_GROUPING_CONFIG.LEGACY_PRODUCTS_SLUG ||
    !tag.parent
  );
}

/**
 * Finds parent tags that correspond to the given parent IDs
 *
 * @param allTags - Complete collection of tags to search in
 * @param parentIds - Set of parent IDs to find
 * @returns Array of parent tags
 */
export function findParentTags(allTags: Tag[], parentIds: Set<number>): Tag[] {
  return allTags.filter(tag => parentIds.has(tag.id));
}

/**
 * Filters tags that are already considered family tags
 *
 * @param tags - Array of tags to filter
 * @returns Array of tags that are family tags
 */
export function filterExistingFamilyTags(tags: Tag[]): Tag[] {
  return tags.filter(isFamilyTag);
}
